import templateUrl from 'servicestack/automations/automation-prompt.htm';
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
//import config from 'servicestack/tags/_config'
//import labels from 'servicestack/tags/_labels'
import modals from 'webmodals/modals'
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config";
import 'servicestack/automations/automation-prompt.scss';

class AutomationPromptController {
    constructor(options) {
        const $ctrl = this;
		basicController($ctrl);
		this.creditRequestConfig = creditRequestConfig;
		$ctrl.recipe = options.recipe;
		$ctrl.automation = options.automation || {};
		$ctrl.request = {};
		if (options.automation) $ctrl.request = options.automation;
		$ctrl.bus = new ServiceBus();
		$ctrl.bus.send('QueryReasonCodes.json').then(function (response) {
			$ctrl.reasonCodes = response.data.results;
		});
		$ctrl.bus.send('QueryCustomFieldValues.json?Id=ReasonCodes').then(function (response) {
			$ctrl.customFieldReasonCodes = response.data.results;
		});
		$ctrl.bus.send('QueryRegistrationStatuses.json?OrderBy=SortOrder').then(function (response) {
			$ctrl.registrationStatuses = response.data.results;
		});
		$ctrl.bus.send('QueryCarts.json?Count=Id&GroupBy=ErpStatus').then(function (response) {
			$ctrl.erpStatuses = response.data.results;
		});
		$ctrl.creditRequestStatuses = $ctrl.creditRequestConfig.creditRequestStatuses;
		var listRecipe = $ctrl.recipe.ingredients.filter(t => t.type === 'list');
		if (listRecipe.length > 0) {
			$ctrl.bus.send('GetAllLists.json').then(function (response) {
				$ctrl.lists = response.data;
			});
		}
		$ctrl.bus.send('QueryFormConfigs.json').then(function (response) {
			$ctrl.forms = response.data.results;
		});
		$ctrl.hours = [
			{
				id: 3,
				name: "3 HOURS",
				description: "3 HOURS"
			},
			{
				id: 12,
				name: "12 HOURS",
				description: "12 HOURS"
			},
			{
				id: 24,
				name: "24 HOURS",
				description: "24 HOURS"
			},
			{
				id: 36,
				name: "36 HOURS",
				description: "36 HOURS"
			},
			{
				id: 72,
				name: "72 HOURS",
				description: "72 HOURS"
			},
			{
				id: 168,
				name: "168 HOURS",
				description: "1 WEEK"
			},
			{
				id: 336,
				name: "336 HOURS",
				description: "2 WEEKS"
			},
			{
				id: 504,
				name: "504 HOURS",
				description: "3 WEEKS"
			}
		];
		$ctrl.shipmentStatuses = [
			{
				id: "SHIPPED",
				name: "SHIPPED",
				description: "SHIPPED"
			},
			{
				id: "TRANSIT",
				name: "TRANSIT",
				description: "TRANSIT"
			},
			{
				id: "DELIVERED",
				name: "DELIVERED",
				description: "DELIVERED"
			}
		];
		$ctrl.bus.send('GetTemplates.json').then(function (response) {
			$ctrl.templates = response.data;
		});
		if ($ctrl.recipe.tags.indexOf('Other') > -1) {
			$ctrl.recipe.recipients = ['Email on form', 'Rep of Record Email', 'Customer Service', 'Customer Service Rep'];
		} else if ($ctrl.recipe.tags.indexOf('Registration') > -1) {
			$ctrl.recipe.recipients = ['Rep of Record Email', 'Registration Contact', 'Customer Service'];
		} else if ($ctrl.recipe.tags.indexOf('Shipments') > -1 || $ctrl.recipe.tags.indexOf('Shopping') > -1) {
			$ctrl.recipe.recipients = ['Rep of Record Email', 'Customer Contact', 'Customer Service'];
		} else if ($ctrl.recipe.tags.indexOf('Activities') > -1) {
			$ctrl.recipe.recipients = ['Rep of Record Email', 'Customer Contact', 'Customer Service'];
		} else {
			$ctrl.recipe.recipients = ['Email on form', 'Rep of Record Email', 'Customer Service'];
		}
		if ($ctrl.recipe.eventType == "CreditRequestUpdated") $ctrl.recipe.recipients = ['Rep of Record Email', 'Customer Contact', 'Customer Service'];

		$ctrl.title = options.title || 'Automation Configuration';
        console.debug($ctrl);
	}

	setIngredient(ingredient, value) {
		const $ctrl = this;
		ingredient.value = value;
	}

    submit() {
		const $ctrl = this;
		//console.info("BL*** got into submit");
		$ctrl.request.ingredients = JSON.stringify($ctrl.recipe.ingredients);
		$ctrl.request.recipeId = $ctrl.recipe.id;
		$ctrl.request.eventType = $ctrl.recipe.eventType;
		$ctrl.request.actionType = $ctrl.recipe.actionType;
		$ctrl.request.tags = $ctrl.recipe.tags;
        $ctrl.bus.send(`${$ctrl.request.id ? 'Upd' : 'Cre'}ateAutomation.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$broadcast("$automationSaved");
                $ctrl.$close($ctrl.request);
            });
    }
}

const AutomationPrompt = {
    open(options) {
        return modals.open(Object.assign({
			size: 'xl automation-prompt',
			preventAutoHeight: true,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: AutomationPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default AutomationPrompt;